import './App.css';
import Groups from './component/Groups/Groups';
import Header from './component/Header/Header';

function App() {
  return (
    <div className="back-color">
      <Header></Header>
      <Groups></Groups>
    </div>
  );
}

export default App;
